import React from 'react';
import PropTypes from 'prop-types';
import YouTube from '../../commons/youtube';
import PenzugyiteljesitesMenu from './PenzugyiteljesitesMenu';

const videoData = [
  { text: 'Pénzügyi teljesítés', id: 'KAxQV77nCGQ' }
];

const PenzugyiteljesitesBase = (props) => {
  let cardStyle = {
    padding: 20
  };

  return (
    <div className="animated fadeIn">
      <div className="row" style={cardStyle}>
        <div className="col-md-12">
          <PenzugyiteljesitesMenu
            globals={props.props.route.globals}
          />
        </div>
      </div>
    </div>
  );
};

PenzugyiteljesitesBase.propTypes = {
  route: PropTypes.object,
};

export default PenzugyiteljesitesBase;
